import { DischargeFormTranslations } from "./types";

export const deTranslations: DischargeFormTranslations = {
    title: "Arztbrief",
    formType: "Brieftyp",
    admissionButton: "Verlegung",
    dischargeButton: "Entlassung",
    admission: "Zielstation",
    selectPlaceholder: "Auswählen...",
    admissionOptions: [
        {
            value: "WARD_DISCHARGE",
            label: "Normalstation",
        },
        {
            value: "HDU_DISCHARGE",
            label: "Überwachungsstation",
        },
        {
            value: "ITU_DISCHARGE",
            label: "Intensivstation",
        },
    ],
    admitting: "Aufnahmeteam",
    admittingOptions: [
        {
            label: "Pulmonologie",
            value: "RESPIRATORY",
        },
        {
            label: "Urologie",
            value: "UROLOGY",
        },
        {
            label: "Kardiologie",
            value: "CARDIOLOGY",
        },
        {
            label: "Gastroenterologie",
            value: "GASTROENTEROLOGY",
        },
        {
            label: "Gynäkologie und Geburtshilfe",
            value: "OBSTETRICS",
        },
        {
            label: "Orthopädie",
            value: "ORTHO",
        },
    ],
    presentation: "Kurze Anamnese",
    presentationTip:
        "Stellen Sie hier alle wesentlichen Aspekte gut nachvollziehbar dar.",
    action: "Ergriffene Maßnahmen",
    follow: "Empfehlungen für die weitere Behandlung",
    clearButton: "Löschen",
    submitButton: "Absenden",
    titleDiagnosis: "Bitte geben Sie zuerst eine Diagnose an:",
    selectPlaceholderDiagnosis: "Auswählen...",
    diagnosisButton: "Diagnose speichern",
};
